import {Component, OnInit} from '@angular/core';
import {saveAs} from 'file-saver';
import {pdfDefaultOptions} from 'ngx-extended-pdf-viewer';
import {ActivatedRoute} from '@angular/router';
import {MenuItem, MessageService} from 'primeng/api';
import {Location} from '@angular/common';
import {CacheService} from '../../services/cache.service';
import {CommonService} from '../../services/common.service';
import {InvoiceAndSoaService} from '../../new-services/invoice-and-soa.service';

@Component({
    selector: 'pdf-viewer-widget',
    templateUrl: './pdf-viewer-widget.component.html',
    styleUrls: ['./pdf-viewer-widget.component.scss']
})
export class PdfViewerWidgetComponent implements OnInit {

    pdfResponse: any;
    viewDocument = false;
    pdfSrc = '';
    documentNumber: any;
    documentType: any;
    home: MenuItem;
    model: MenuItem[];
    documentGid: string;
    isLoading: boolean;
    document: any;
    allowToExport: any;

    constructor(private cacheService: CacheService,
                private activatedRoute: ActivatedRoute,
                private location: Location,
                private commonService: CommonService,
                private messageService: MessageService,
                private invoiceAndSoaService: InvoiceAndSoaService) {
        pdfDefaultOptions.assetsFolder = 'bleeding-edge';
    }

    ngOnInit(): void {
        this.activatedRoute
            .queryParams
            .subscribe(
                (x: any) => {
                    this.documentNumber = x.documentNumber;
                    this.documentType = x.documentType;
                    this.documentGid = x.documentGid;
                    this.allowToExport = x.allowToExport;
                    this.getDocumentByDocumentGid(x.documentGid);
                }
            );
        this.home = {icon: 'pi pi-home', routerLink: '/'};
        if (this.documentType === 'Invoice') {
            this.model = [
                {label: this.documentType, routerLink: '/invoices'},
                {label: this.documentNumber}
            ];
        } else {
            this.model = [
                {label: this.documentType, routerLink: '/booking-summary'},
                {label: this.documentNumber ? this.documentNumber : '-'}
            ];
        }

    }

    downloadPdf() {
        saveAs(this.pdfSrc, this.documentType + ' - ' + this.documentNumber);
    }

    printPdf() {
        this.messageService.add({
            summary: 'Feature Message !',
            severity: 'info',
            detail: 'Feature will be available soon',
            key: 'pdf-error',
        });
    }

    goBack() {
        this.location.back();
    }

    closeViewer() {
        this.viewDocument = false;
    }

    getDocumentByDocumentGid(documentGid: string) {
        this.isLoading = true;
        this.invoiceAndSoaService
            .getDocumentByDocumentGid(documentGid)
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.pdfSrc = URL.createObjectURL(x);
                }, error => {
                    this.isLoading = false;
                    this.messageService.add({
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        summary: 'Download Error !',
                        key: 'pdf-error'
                    });
                    console.log(error?.message ? error?.message : error);
                }
            );
    }
}
